<template>
  <PageLayout>
    <!-- <Header /> -->
    <!-- <GlobalNavigationBar /> -->
    <slot name="gnb">
    </slot>  
    <!---------- 시작 : OuterWrap ---------->
    <div id="outer-wrap">
      <LeftMenu v-if="useLeft" />
      <SubContentTemplate :isFull="!useLeft">
        <template v-slot:body>
          <slot></slot>
        </template>
      </SubContentTemplate>
    </div>
    <!---------- 끝 : wrapper ---------->
  </PageLayout>
</template>

<script>
import { PageLayout } from '@appbase/templates'
import { LeftMenu } from '../components/common'
import SubContentTemplate from './SubContentTemplate.vue'
export default {
  components: { PageLayout, LeftMenu, SubContentTemplate },
  props: { useLeft: { type: Boolean, default: true } },
}
</script>

<style></style>
